import { observer } from 'mobx-react-lite';
import React from 'react';
import GroupSearchModal from 'components/groups-dashboard/GroupSearchModal';
import ConfirmNewGroupModal from 'components/groups-dashboard/ConfirmNewGroupModal';
import RemoveGroupModal from 'components/common/group/content/RemoveGroupModal';
import { useGroupDashboardPageStore } from 'store/pages/groups-dashboard/pageStore';
import { useRootStore } from 'store/rootStore';
import { bpHistory } from 'global/bpHistory';
import { GeneralRouteV2Id, ROUTES_CONFIG_V2 } from 'routes/routesConfigV2';
import ActionsPanel from '../DashboardActionsPanel';
import ArchiveGroupModal from '../../common/group/content/ArchiveGroupModal';

const GroupsActionPanel: React.FC = observer(() => {
  const [showModal, setShowModal] = React.useState(false);
  const [buildProposal, setBuildProposal] = React.useState(false);
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);

  const {
    groupInteractionDelegate: { archiveModal, removeModal, selectedGroup, archiveGroup, removeGroup },
  } = useGroupDashboardPageStore();
  const { domainStoreV2 } = useRootStore();

  const onBuildProposal = (withBuildProposal: boolean): void => {
    setShowModal(true);
    setBuildProposal(withBuildProposal);
  };

  const onPanelAction = (): void => {
    if (domainStoreV2.groupInitiationRedirect) {
      bpHistory.push(ROUTES_CONFIG_V2[GeneralRouteV2Id.INITIATE_GROUP].path);
    }
    onBuildProposal(true);
  };

  const onSearchGroup = (): void => {
    onBuildProposal(false);
  };

  return (
    <>
      <ActionsPanel
        searchButtonTitle="Search Groups"
        onSearch={onSearchGroup}
        actionButtonTitle="Build Proposal"
        onAction={domainStoreV2.imqSponsor ? undefined : onPanelAction}
      />
      <GroupSearchModal
        onAction={(): void => {
          setShowConfirmModal(true);
          setShowModal(false);
        }}
        show={showModal}
        withBuildProposal={buildProposal}
        onClose={(): void => setShowModal(false)}
      />
      <ConfirmNewGroupModal show={showConfirmModal} onClose={(): void => setShowConfirmModal(false)} />
      <ArchiveGroupModal
        show={archiveModal.isVisible}
        onClose={archiveModal.close}
        onAction={archiveGroup}
        groupName={selectedGroup.name}
      />
      <RemoveGroupModal
        show={removeModal.isVisible}
        onClose={removeModal.close}
        onAction={removeGroup}
        groupName={selectedGroup.name}
      />
    </>
  );
});

export default GroupsActionPanel;
